export default __webpack_public_path__ + "static/media/cooker.13a9ff9a.jpg";